<template>
  <div class="yulan-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div v-if="!is304">
      <div class="header-bg">
        <van-sticky z-index="100">
          <div
            class="content-nav-bar"
            :class="bodyOffsetTop <= contentNavBar ? 'sticky-header' : ''"
            :style="`backdrop-filter: blur(${filterNum}px)`"
          >
            <van-nav-bar title="多因子回测预览">
              <template #left>
                <van-icon name="arrow-left" size="18" @click="goBack" />
              </template>
            </van-nav-bar>
          </div>
        </van-sticky>

        <div class="yulan-content">
          <div class="header">
            <div class="title">
              <p class="name">多因子回测预览</p>
            </div>
          </div>

          <div class="collapse">
            <FactorArgumentsModal></FactorArgumentsModal>
            <!-- <p class="title" @click="handleClickShowAll">
              · 因子池内容
              <span v-if="checkedYzList.length > 2">
                <van-icon name="arrow-down" v-if="num === 2" />
                <van-icon name="arrow-up" v-else />
              </span>
            </p>
            <div class="yz-list">
              <van-row gutter="8">
                <template v-for="(item, index) in checkedYzList">
                  <van-col span="12" :key="index" v-if="index < num">
                    <p class="li">{{ item.FactorName }}</p>
                  </van-col>
                </template>
              </van-row>
            </div> -->
          </div>

          <div class="btm-style" ref="body">
            <div ref="tabs">
              <van-sticky :offset-top="contentNavBar - 2" z-index="99">
                <van-tabs v-model="active" @change="handleClickTabs">
                  <van-tab title="评级报告"></van-tab>
                  <van-tab title="回测分析"></van-tab>
                  <van-tab title="历史明细"></van-tab>
                </van-tabs>
              </van-sticky>
            </div>

            <div id="section1" ref="section1">
              <DyzPjbg
                :ReportGradeResult="Obj.apiData.ReportGradeResult"
                :startDate="Obj.startDate"
                :endDate="Obj.endDate"
              ></DyzPjbg>
            </div>

            <p
              style="height: 8px"
              :style="
                $route.query.themeStyleVs == 2 ? 'background:#0B0F14' : 'background: #f8f9fc; '
              "
            ></p>

            <div id="section2" ref="section2">
              <DyzHcfx
                :tabsHeight="tabsHeight"
                :headerHeight="contentNavBar"
                :BacktestAnalysisResult="Obj.apiData.BacktestAnalysisResult"
                :holdPeriodList="Obj.holdPeriodList"
              ></DyzHcfx>
            </div>

            <p
              style="height: 8px"
              :style="
                $route.query.themeStyleVs == 2 ? 'background:#0B0F14' : 'background: #f8f9fc; '
              "
            ></p>

            <div id="section3" ref="section3">
              <DyzLsmx :Obj="Obj" :tabsHeight="tabsHeight" :headerHeight="contentNavBar"></DyzLsmx>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom-btn">
        <div v-if="type === null" class="btn_class">
          <van-button
            style="width: 140px"
            class="hcBtn"
            type="info"
            @click="saveHc(0)"
            :loading="loadingHc"
            :disabled="btnDisabled"
            loading-text="更新中..."
            v-if="publicHcID && btnMsg === '更新回测'"
            >更新回测</van-button
          >

          <van-button
            style="width: 140px"
            class="hcBtn"
            type="info"
            :disabled="btnDisabled"
            @click="saveHc(1)"
            :loading="loadingHc"
            loading-text="保存中..."
            v-if="
              (!publicHcID && btnMsg === '保存为回测') || (publicHcID && btnMsg === '保存为回测')
            "
            >保存为回测</van-button
          >

          <button @click="handleClickShowOverlay" v-if="type !== null" class="clBtn">
            更新多因子策略
          </button>
          <button @click="handleClickShowOverlay" v-else class="clBtn">保存为多因子策略</button>
        </div>

        <div v-if="type === 'source_dyzhcDetails'" class="btn_class">
          <van-button
            class="hcBtn"
            type="info"
            @click="saveHc(0)"
            :loading="loadingHc"
            loading-text="更新中..."
            v-if="publicHcID && !btnDisabled"
            >更新回测</van-button
          >

          <van-button
            class="hcBtn"
            type="info"
            :disabled="btnDisabled"
            @click="saveHc(0)"
            :loading="loadingHc"
            loading-text="更新中..."
            v-else
            >更新回测</van-button
          >
        </div>

        <div v-if="type === 'source_dyzclDetails'" style="width: 100%">
          <button
            @click="handleClickShowOverlay"
            v-if="type === 'source_dyzclDetails'"
            class="clBtn"
          >
            更新多因子策略
          </button>
          <button @click="handleClickShowOverlay" v-else class="clBtn">保存为多因子策略</button>
        </div>
      </div>

      <van-overlay :show="showOverlay">
        <div class="wrapper-overlay" @click.stop>
          <van-form @submit="saveCl">
            <p class="wrapper-title">
              {{ type === 'source_dyzclDetails' ? '更新多因子策略' : '保存多因子策略' }}
            </p>

            <p class="wrapper-label">多因子策略名称</p>
            <div class="name">
              <van-field
                v-model="clName"
                autosize
                maxlength="10"
                show-word-limit
                placeholder="添加策略的名称"
                :rules="[{ required: true, message: '请填写策略名称' }]"
              />
            </div>
            <p class="wrapper-label">策略描述</p>
            <van-field
              v-model="clDetails"
              rows="2"
              autosize
              type="textarea"
              maxlength="50"
              placeholder="请输入描述"
              show-word-limit
              :rules="[{ required: true, message: '' }]"
            />

            <div class="wrapper-btn">
              <van-button class="left" @click="showOverlay = false" native-type="button"
                >取消</van-button
              >
              <!-- getClientFun(); -->

              <van-button
                type="info"
                class="right"
                :loading="loadingCl"
                :loading-text="type === 'source_dyzclDetails' ? '更新中...' : '保存中...'"
                native-type="submit"
                >{{ type === 'source_dyzclDetails' ? '确认更新' : '保存策略' }}
              </van-button>
            </div>
          </van-form>
        </div>
      </van-overlay>
    </div>

    <!-- 没有慧豆时页面显示 -->
    <NotHd v-else></NotHd>

    <takeOut
      :show="takeShow"
      :name="takeName"
      :btnText="takeBtnName"
      type="bccl"
      @cancelBasis="cancelBasis"
      @linkGo="linkGo"
    ></takeOut>
  </div>
</template>

<script>
import mixin from '@/mixins/index.js';
import DyzPjbg from '@/components/details/DyzPjbg.vue';
import DyzHcfx from '@/components/details/DyzHcfx.vue';
import DyzLsmx from '@/components/details/DyzLsmx.vue';
import { addMyDyzHc, updateMyDyzHc, addMyCl, updateMyDyzCl } from '@/api/create';
import VueScrollTo from 'vue-scrollto';
import { mapMutations } from 'vuex';
import NotHd from '@/components/notHd/notHd.vue';
import { getClientRedis } from '@/api/index.js';
import { strToHexCharCode,factorCombinationToCode } from '@/utils/format';

var Base64 = require('js-base64').Base64;
export default {
  name: 'Dyz-preview',
  mixins: [mixin],
  data() {
    return {
      is304: false,
      index_info: 1,
      num: 2,
      active: 0,
      ReportGradeResult: {},
      starDate: '',
      endDate: '',
      BacktestAnalysisResult: [],
      periodArr: [],
      condition: {},
      loadingHc: false,
      loadingCl: false,
      distanceFromTop: 0,
      filterNum: 0,
      tabsHeight: 0,
      bodyOffsetTop: 0,
      showOverlay: false,
      clName: '',
      clDetails: '',
      btnType: null,
      scrollTop: 0,
      section1: 0,
      section2: 0,
      section3: 0,
      timeoutId: null, // 添加 timeoutId 属性，用于存储 setTimeout 的返回值
      btnMsg: '保存为回测',
      takeShow: false,
      takeName: '',
      takeBtnName: '',
      isShowKd: false,
      themeStyleVs: 0
    };
  },
  components: {
    DyzPjbg,
    DyzHcfx,
    DyzLsmx,
    NotHd
  },
  filters: {},
  //计算属性
  computed: {
    checkedYzList: function () {
      return this.$store.state.checkedYzList; // 获取全局状态
    },
    Obj: function () {
      return this.$store.state.Obj; // 获取全局状态
    },
    contentNavBar: function () {
      return this.$store.state.contentNavBar; // 获取全局状态
    },
    publicHcID: function () {
      return this.$store.state.publicHcID; // 获取vuex的id 要是存在id走编辑逻辑
    },
    type: function () {
      return this.$store.state.type; // 来判断是保存策略还是更新
    },
    btnDisabled: function () {
      return this.$store.state.btnDisabled; // 用来控制回测是变灰还是现实更新
    },
    groupYzList() {
        return this.$store.state.groupYzList;
    },
    checkedYzType(){
        return this.$store.state.checkedYzType;
    }
  },
  watch: {
    showOverlay: function (i) {
      if (i) {
        this.clName = this.Obj.name || '';
        this.clDetails = this.Obj.desc || '';
      } else {
        this.clName = '';
        this.clDetails = '';
      }
    }
  },
  created() {
    // this.getClientFun();
    if (window.DzhAppJs) {
      let obj = {
        navBarHidden: 1,
        titleHidden: 1
      };

      DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('setTitleStyle', obj, '');
    }
  },
  mounted() {
    // if (window.DzhAppJs) {
    //   DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('', 'true', 'interceptOnKeyDown'); //安卓里面禁用返回功能
    // }

    if (this.publicHcID) {
      this.btnMsg = '更新回测';
    } else {
      this.btnMsg = '保存为回测';
    }

    this.btnType = this.$route.query.type;
    this.clName = this.Obj.name || '';
    this.clDetails = this.Obj.desc || '';
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('scroll', this.handleScrollTab);

    //获取评级报告和回测分析的高度
    var contentTabs = this.$refs['tabs'];
    this.tabsHeight = contentTabs.offsetHeight;

    this.bodyOffsetTop = this.$refs.body.getBoundingClientRect().top;
    this.section1 = this.$refs.section1.getBoundingClientRect().top;
    this.section2 = this.$refs.section2.getBoundingClientRect().top;
    this.section3 = this.$refs.section3.getBoundingClientRect().top;
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('scroll', this.handleScrollTab);
  },
  methods: {
    ...mapMutations(['resetState']),

    //查询是否显示扣豆
    getClientFun() {
      var _this = this;
      getClientRedis({})
        .then((res) => {
          if (res.err === 200) {
            var data = JSON.parse(res.data);
            _this.setLocalData(data);
            if (data.bccl === 'true') {
              _this.isShowKd = false;
            } else {
              _this.isShowKd = true;
            }
          } else {
            _this.isShowKd = true;
            _this.setLocalData();
          }
        })
        .catch(() => {
          _this.isShowKd = true;
          _this.setLocalData();
        });
    },

    //监听ref=body的滚滚动条距离用来控制header的背景色显示隐藏
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.bodyOffsetTop = this.$refs.body.getBoundingClientRect().top;
      this.filterNum = (this.scrollTop / (this.bodyOffsetTop / 2)).toFixed(2);
    },

    handleScrollTab() {
      if (this.$refs.section1.getBoundingClientRect().top <= this.tabsHeight + this.contentNavBar) {
        this.active = 0;
      }
      if (this.$refs.section2.getBoundingClientRect().top <= this.tabsHeight + this.contentNavBar) {
        this.active = 1;
      }
      if (this.$refs.section3.getBoundingClientRect().top <= this.tabsHeight + this.contentNavBar) {
        this.active = 2;
      }
    },

    scrollToSection(sectionId) {
      VueScrollTo.scrollTo(`#${sectionId}`, 500, {
        offset: -120 // 调整偏移量以适应您的布局
      });
    },

    //手动点击切换的时候清除监听 然后1s之后再次恢复防止滚动和手动点击冲突
    handleClickTabs: function (i) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      } else {
        window.removeEventListener('scroll', this.handleScrollTab);
      }

      if (i === 0) {
        this.scrollToSection('section1');
      } else if (i === 1) {
        this.scrollToSection('section2');
      } else if (i === 2) {
        this.scrollToSection('section3');
      }

      this.timeoutId = setTimeout(() => {
        window.addEventListener('scroll', this.handleScrollTab);
        this.timeoutId = null;
      }, 1500);
    },
    //把里面所有的FactorName放在一个数组里面
    extractFactorNames: function (data) {
      var factorNames = [];

      function recursiveExtract(obj) {
        if (obj && typeof obj === 'object') {
          if (obj.hasOwnProperty('FactorName')) {
            factorNames.push(obj.FactorName);
          }

          for (let key in obj) {
            if (Array.isArray(obj[key])) {
              obj[key].forEach((item) => recursiveExtract(item));
            } else if (typeof obj[key] === 'object') {
              recursiveExtract(obj[key]);
            }
          }
        }
      }

      recursiveExtract(data);

      return factorNames;
    },

    handleClickShowAll: function () {
      if (this.num === 2) {
        this.num = this.checkedYzList.length;
      } else {
        this.num = 2;
      }
    },

    //获取id和name
    extractIdAndFactorName: function (data) {
      var ids = [];
      var factorNames = [];

      data.forEach((item) => {
        ids.push(item.ID);
        factorNames.push(item.FactorName);
      });

      return {
        ids,
        factorNames
      };
    },
    filterData: function (data) {
      var filteredData = [];
      for (var i = 0; i < data.length; i++) {
        var item = data[i];
        var filteredItem = {};
        filteredItem.ID = item.ID;
        filteredItem.FactorName = item.FactorName;
        filteredItem.RiZhangFu = item.RiZhangFu;
        filteredItem.XinHaoShuLiang = item.XinHaoShuLiang;
        filteredItem.yzType = item.yzType;
        filteredData.push(filteredItem);
      }
      return filteredData;
    },
    //保存为回测
    saveHc: function (i) {
      if (i) {
        this.addMyDyzHcFun();
      } else {
        this.updateMyDyzHcFun();
      }
    },

    //保存多因子回测
    addMyDyzHcFun: function () {
      let _this = this;

    // 组合因子交并集
    var hexYzObj = factorCombinationToCode(_this.checkedYzList,_this.groupYzList,_this.checkedYzType);


      var collection_condition_obj = {
        composeType: _this.checkedYzType,
        yzList: _this.checkedYzList,
        children: _this.groupYzList
      };

      _this.loadingHc = true;
      var params = {
        record_id: _this.Obj.apiData.HashID, //回测ID : 云平台的hashID
        f_id_arr: hexYzObj.hexyzIds, //string :"", 因子id 16进制
        f_name_arr: _this.extractIdAndFactorName(_this.checkedYzList).factorNames.toString(), //string :""
        chigu_cycle: _this.Obj.holdPeriodList, //持股周期: 1,2,3,4,5,6,99
        chigu_type: _this.Obj.isCustomSelected ? 1 : 2, //持股类型: 0默认 1自定义周期 2持股周期
        starDate: _this.Obj.startDate, //回测开始时间 : 20220101
        endDate: _this.Obj.endDate, //回测结束时间 : 20230101
        BestAvgCycle: _this.Obj.apiData.ReportGradeResult.BestAvgCycle, //最优平均涨幅对应的持股周期<==> 最优均收益
        BestAvgRate: _this.Obj.apiData.ReportGradeResult.BestAvgRate, //最优平均涨幅 <==>最优均涨幅
        MaxRiseCycle: _this.Obj.apiData.ReportGradeResult.MaxRiseCycle, //最大上涨概率持股  <=> 最优胜率持股
        MaxRiseRate: _this.Obj.apiData.ReportGradeResult.MaxRiseRate, //最大上涨概率涨幅  <=> 最优胜率涨幅
        collection_condition: JSON.stringify(collection_condition_obj), //条件JSON
        collection_type: _this.checkedYzType=='jj'? 1 : 2, //交并集状态: 0没有交并集 1交集组合 2 并集组合
        collection_info: hexYzObj.idArrayToStr, //_this.extractIdAndFactorName(_this.checkedYzList).ids.toString() //id,id,id,id
        type_info: _this.$route.query.yzType == 'ETF' ? 2 : 1 //1- A 股 2-ETF
      };
      return addMyDyzHc(params)
        .then((res) => {
          _this.loadingHc = false;
          _this.$toast(res.msg);
          if (res.err === 200) {
            _this.$store.commit('setPublicHcID', res.data.h_id);
            _this.$store.commit('setBtnDisabled', true);
          }
        })
        .catch((err) => {
          _this.loadingHc = false;
          _this.$toast(err);
        });
    },
    //更新多因子回测
    updateMyDyzHcFun: function () {
      let _this = this;

      // 组合因子交并集
      var hexYzObj = factorCombinationToCode(_this.checkedYzList,_this.groupYzList,_this.checkedYzType);

      var collection_condition_obj = {
        composeType: _this.checkedYzType,
        yzList: _this.checkedYzList,
        children: _this.groupYzList
      };

      _this.loadingHc = true;
      var params = {
        h_id: _this.publicHcID,
        record_id: _this.Obj.apiData.HashID, //回测ID : 云平台的hashID
        f_id_arr: hexYzObj.hexyzIds, //string :"", 因子id 16进制
        f_name_arr: _this.extractIdAndFactorName(_this.checkedYzList).factorNames.toString(), //string :""
        chigu_cycle: _this.Obj.holdPeriodList, //持股周期: 1,2,3,4,5,6,99
        chigu_type: _this.Obj.isCustomSelected ? 1 : 2, //持股类型: 0默认 1自定义周期 2持股周期
        starDate: _this.Obj.startDate, //回测开始时间 : 20220101
        endDate: _this.Obj.endDate, //回测结束时间 : 20230101
        BestAvgCycle: _this.Obj.apiData.ReportGradeResult.BestAvgCycle, //最优平均涨幅对应的持股周期<==> 最优均收益
        BestAvgRate: _this.Obj.apiData.ReportGradeResult.BestAvgRate, //最优平均涨幅 <==>最优均涨幅
        MaxRiseCycle: _this.Obj.apiData.ReportGradeResult.MaxRiseCycle, //最大上涨概率持股  <=> 最优胜率持股
        MaxRiseRate: _this.Obj.apiData.ReportGradeResult.MaxRiseRate, //最大上涨概率涨幅  <=> 最优胜率涨幅
        collection_condition: JSON.stringify(collection_condition_obj), //条件JSON
        collection_type: 3, //交并集状态: 0没有交并集 1交集组合 2 并集组合
        collection_info: hexYzObj.idArrayToStr, //_this.extractIdAndFactorName(_this.checkedYzList).ids.toString() //id,id,id,id
      };
      return updateMyDyzHc(params)
        .then((res) => {
          _this.loadingHc = false;
          _this.$toast(res.msg);
          if (res.err === 200) {
            _this.$store.commit('setBtnDisabled', true);

            var url = `${
              _this.getBaseUrl() +
              '/dyz-details?token=' +
              _this.$route.query.token +
              '&source=dyzcl&h_id=' +
              _this.publicHcID +
              '&tab=hc&smallTab=0' +
              '&DZHSPECIAL=4194569&mySource=' +
              _this.$route.query.mySource
            }`;

            if (_this.publicHcID && _this.btnDisabled && _this.type === 'source_dyzhcDetails') {
              window.location.href = `dzh_browser_url&goto=0&screen=263&nextUrl=${Base64.encode(
                url
              )}`;
            }

            // _this.$router.push({
            //   path: '/dyz-details',
            //   name: 'Dyz-details',
            //   query: {
            //     source: 'dyzcl', //用来标注是从多因子还是量化过去的
            //     token: this.$route.query.token || '',
            //     h_id: _this.publicHcID,
            //     tab: 'hc',
            //     smallTab: 0
            //   }
            // });
          }
        })
        .catch((err) => {
          _this.loadingHc = false;
          _this.$toast(err);
        });
    },
    handleClickShowOverlay: function () {
      // if (this.isShowKd) {
      //   this.takeName = '每次保存多因子策略需消耗 2个慧豆';
      //   this.takeBtnName = '继续保存';
      //   this.takeShow = true;
      //   return false;
      // }
      this.showOverlay = true;
    },
    //点击保存或者更新
    saveCl: async function () {
      if (this.type === 'source_dyzclDetails') {
        this.updateMyDyzClFun();
      } else {
        this.addMyClFun();
      }
    },

    cancelBasis: function () {
      this.takeShow = false;
    },

    linkGo: function () {
      this.takeShow = false;
      this.showOverlay = true;
    },

    //保存策略
    addMyClFun: function () {
      let _this = this;

      // 组合因子交并集
      var hexYzObj = factorCombinationToCode(_this.checkedYzList,_this.groupYzList,_this.checkedYzType);



      var collection_condition_obj = {
        composeType: _this.checkedYzType,
        yzList: _this.checkedYzList,
        children: _this.groupYzList
      };

      _this.loadingCl = true;

      var params = {
        s_name: _this.clName, //策略名称
        s_desc: _this.clDetails, //策略描述
        f_id_arr: hexYzObj.hexyzIds, //string :"", 因子id 16进制
        f_name_arr: _this.extractIdAndFactorName(_this.checkedYzList).factorNames.toString(), //string :""
        s_chigu_cycle: _this.Obj.holdPeriodList, //持股周期: 1,2,3,4,5,6,99
        s_chigu_type: _this.Obj.isCustomSelected ? 1 : 2, //持股类型: 0默认 1自定义周期 2持股周期
        HistoryCount: _this.Obj.apiData.ReportGradeResult.HistoryCount, //历史信号数量
        BestAvgCycle: _this.Obj.apiData.ReportGradeResult.BestAvgCycle, //最优平均涨幅对应的持股周期<==> 最优均收益
        BestAvgRate: _this.Obj.apiData.ReportGradeResult.BestAvgRate, //最优平均涨幅 <==>最优均涨幅
        MaxRiseCycle: _this.Obj.apiData.ReportGradeResult.MaxRiseCycle, //最大上涨概率持股  <=> 最优胜率持股
        MaxRiseRate: _this.Obj.apiData.ReportGradeResult.MaxRiseRate, //最大上涨概率涨幅  <=> 最优胜率涨幅
        RiZhangFu: 0, //日涨幅
        XinHaoShuLiang: 0, //当日信号数量
        collection_condition: JSON.stringify(collection_condition_obj), //条件JSON
        collection_type: 3, //交并集状态: 0没有交并集 1交集组合 2 并集组合
        collection_info: hexYzObj.idArrayToStr, //id,id,id,id
        type_info: _this.$route.query.yzType == 'ETF' ? 2 : 1 //1- A 股 2-ETF
      };

      return addMyCl(params)
        .then((res) => {
          _this.loadingCl = false;
          _this.$toast(res.msg);
          if (res.err === 200) {
            _this.showOverlay = false;

            var url = `${
              _this.getBaseUrl() +
              '/clDetail?token=' +
              _this.$route.query.token +
              '&s_id=' +
              res.data.s_id +
              '&DZHSPECIAL=4194569'
            }`;

            window.location.href = `dzh_browser_url&goto=0&screen=263&nextUrl=${Base64.encode(
              url
            )}`;

            setTimeout(() => {
              _this.resetState(); //重置部分vuex
            }, 500);
          } else if (res.err === 304) {
            _this.is304 = true;
            window.location.href = window.config.hdTips;
          } else if (res.err === 305) {
            _this.$toast('功能使用异常，请检查您的登录状态');
          }
        })
        .catch((err) => {
          console.log(err, 'err');
          _this.loadingCl = false;
          _this.$toast(err);
        });
    },

    //编辑策略
    updateMyDyzClFun: function () {
      let _this = this;

     // 组合因子交并集
    var hexYzObj = factorCombinationToCode(_this.checkedYzList,_this.groupYzList,_this.checkedYzType);


      var collection_condition_obj = {
        composeType: _this.checkedYzType,
        yzList: _this.checkedYzList,
        children: _this.groupYzList
      };

      _this.loadingCl = true;

      var params = {
        s_id: _this.publicHcID,
        s_name: _this.clName, //策略名称
        s_desc: _this.clDetails, //策略描述
        f_id_arr: hexYzObj.hexyzIds, //string :"", 因子id 16进制
        f_name_arr: _this.extractIdAndFactorName(_this.checkedYzList).factorNames.toString(), //string :""
        s_chigu_cycle: _this.Obj.holdPeriodList, //持股周期: 1,2,3,4,5,6,99
        s_chigu_type: _this.Obj.isCustomSelected ? 1 : 2, //持股类型: 0默认 1自定义周期 2持股周期
        HistoryCount: _this.Obj.apiData.ReportGradeResult.HistoryCount, //历史信号数量
        BestAvgCycle: _this.Obj.apiData.ReportGradeResult.BestAvgCycle, //最优平均涨幅对应的持股周期<==> 最优均收益
        BestAvgRate: _this.Obj.apiData.ReportGradeResult.BestAvgRate, //最优平均涨幅 <==>最优均涨幅
        MaxRiseCycle: _this.Obj.apiData.ReportGradeResult.MaxRiseCycle, //最大上涨概率持股  <=> 最优胜率持股
        MaxRiseRate: _this.Obj.apiData.ReportGradeResult.MaxRiseRate, //最大上涨概率涨幅  <=> 最优胜率涨幅
        RiZhangFu: 0, //日涨幅
        XinHaoShuLiang: 0, //当日信号数量
        collection_condition: JSON.stringify(collection_condition_obj), //条件JSON
        collection_type: 3, //交并集状态: 0没有交并集 1交集组合 2 并集组合
        collection_info: hexYzObj.idArrayToStr //id,id,id,id
      };

      updateMyDyzCl(params)
        .then((res) => {
          _this.loadingCl = false;
          _this.$toast(res.msg);
          if (res.err === 200) {
            _this.showOverlay = false;

            var url = `${
              _this.getBaseUrl() +
              '/clDetail?token=' +
              _this.$route.query.token +
              '&s_id=' +
              _this.publicHcID +
              '&DZHSPECIAL=4194568'
            }`;

            window.location.href = `dzh_browser_url&goto=0&screen=263&nextUrl=${Base64.encode(
              url
            )}`;

            setTimeout(() => {
              _this.resetState(); //重置部分vuex
            }, 500);
          }
        })
        .catch((err) => {
          _this.loadingCl = false;
          _this.$toast(err);
        });
    },
    goBack: function () {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
.yulan-info {
  .header-bg {
    height: 100vh;
  }

  .header {
    padding: 20px 16px;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .name {
        font-weight: 500;
        font-size: 20px;
        color: #222;
      }
      .edit {
        width: 60px;
        height: 30px;
        background: #286df7;
        border-radius: 4px;
        font-weight: 500;
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .collapse {
    padding: 0 16px 22px 16px;
    .title {
      font-weight: 700;
      font-size: 14px;
      color: #286df7;
    }
    .yz-list {
      .li {
        height: 34px;
        line-height: 34px;
        border: 1px solid #fff;
        border-radius: 4px;
        background: linear-gradient(to bottom right, #e6edff 10%, #fff 60%);
        padding: 0 12px;
        margin-top: 6px;
        font-weight: 500;
        font-size: 12px;
        color: rgba(55, 58, 77, 0.9);
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
  }
  .btm-style {
    border-radius: 8px 8px 0 0;
    background: #fff;
    padding-bottom: 80px;
  }
  .yulan-content {
    .van-tabs {
      border-radius: 8px 8px 0 0;
      overflow: hidden;
    }
    ::v-deep {
      .van-tab {
        font-weight: 400;
        font-size: 14px;
        color: #373a4d;
      }
      .van-tab--active {
        font-weight: 600 !important;
        font-size: 14px !important;
        color: #286df7 !important;
      }
      .van-tabs__line {
        background: #286df7;
      }
    }
  }
  .bottom-btn {
    position: fixed;
    bottom: 34px;
    width: 100%;
    padding: 0 18.5px;
    z-index: 9;
    button {
      width: 100%;
    }

    .hcBtn {
      border: none;
      height: 40px;
      border-radius: 20px;
      padding: 0px 16px;
      background: #fff;
      border: 1px solid #286df7;
      color: #286df7;
      flex-shrink: 0;
      margin-right: 8px;
    }
    .clBtn {
      border: none;
      height: 40px;
      border-radius: 20px;
      padding: 0px 16px;
      background: #286df7;
      border: 1px solid #286df7;
      color: #fff;
      width: 100%;
    }
    .btn_class {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  ::v-deep {
    .van-overlay {
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 100;
      .wrapper-overlay {
        width: 285px;
        border-radius: 10px;
        padding: 16px;
        background: #fff;
        .wrapper-title {
          text-align: center;
          font-size: 16px;
          color: #222;
          margin-bottom: 16px;
        }
        .wrapper-label {
          font-size: 14px;
          color: #555;
          margin-bottom: 4px;
        }
        .name {
          position: relative;
          .van-cell {
            height: 38px;
            padding: 8px 10px;
          }
          .van-field__word-limit {
            position: absolute;
            right: 7px;
            top: 0px;
          }
        }
        .van-cell {
          border: 0.5px solid #e5e5e5;
          border-radius: 4px;
          margin-bottom: 16px;
          padding: 8px 10px;
          &::after {
            border: none;
          }
        }
        .van-field__control {
          &::placeholder {
            font-size: 14px;
          }
        }
      }
      .wrapper-btn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        button {
          border: none;
          height: 36px;
          font-size: 14px;
          border-radius: 6px;
          width: 50%;
        }
        .left {
          background: #f5f5f6;
          color: #222;
          margin-right: 12px;
        }
        .rught {
          background: #286df7;
          color: #fff;
          margin-left: 12px;
        }
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .yulan-content {
    .name,
    .title {
      color: #e4e9fe !important;
    }
    .yz-list {
      .li {
        border: 1px solid rgba(255, 255, 255, 0.1);
        background: rgba(255, 255, 255, 0.1);
        color: #e4e9fe;
      }
    }
    ::v-deep {
      .btm-style,
      .van-tabs__nav {
        background: #191a24;
      }
      .van-tab {
        color: #e4e9fe;
      }
    }
  }
  .wrapper-overlay {
    background: #181a23 !important;
    .wrapper-title {
      color: #e4e9fe !important;
    }
    .wrapper-label {
      color: #aab9d1 !important;
    }
    .van-cell {
      background: none;
      border: 1px solid #3b3d43 !important;
    }
    ::v-deep {
      .van-field__control {
        color: #e4e9fe !important;
      }
    }
    .wrapper-btn {
      .left {
        background: #46484f;
        color: #aab9d1;
      }
    }
  }
  .hcBtn {
    background: #46484f !important;
    border: 1px solid #46484f !important;
    color: #e4e9fe !important;
  }
  .van-button--disabled {
    background: #25262a !important;
    border: 1px solid #25262a !important;
    color: #e4e9fe !important;
  }
}
</style>
